<template>
  <div>
    <HeaderBar></HeaderBar>
    <RetailPartners></RetailPartners>
    <FooterBar></FooterBar>
  </div>
</template>

<script>

import HeaderBar from '../components/site/Header/Header'
import FooterBar from '../components/site/Footer/Footer'
import RetailPartners from '../components/RetailPartners'

export default {
  components: {
    HeaderBar,
    RetailPartners,
    FooterBar
  }
}

</script>



// WEBPACK FOOTER //
// RetailPartners.vue?5db2d7c4